interface LinkResolverPropsType {
  uid: string;
  type: string;
}

const linkResolver = (doc: LinkResolverPropsType) => {
  if (doc.uid === 'home') {
    return `/`;
  }

  if (doc.type === 'contact') {
    return `/${doc.uid}`;
  }

  if (doc.type === 'page') {
    return `/${doc.uid}`;
  }

  if (doc.type === 'legal') {
    return `/${doc.uid}`;
  }

  if (doc.type === 'blog_index') {
    return '/blog';
  }

  if (doc.type === 'guides_index') {
    return '/guides';
  }

  if (doc.type === 'case_studies_index') {
    return '/case-studies';
  }

  if (doc.type === 'blog_post') {
    return `/blog/${doc.uid}`;
  }

  if (doc.type === 'guides_post') {
    return `/guides/${doc.uid}`;
  }

  if (doc.type === 'case_studies_post') {
    return `/case-studies/${doc.uid}`;
  }

  return '/';
};

export default linkResolver;
